<template>
  <div class="Parent">
    <div class="HomePageMargin grid">
      <img
        class="image"
        src="~@/assets/homePage/pole_purchase_img-desktop.webp"
      />
      <div class="content">
        <h3 class="smallHeader">{{ $t('infra_takeover.small_header') }}</h3>
        <h4 class="bigHeader">{{ $t('infra_takeover.big_header') }}</h4>
        <p class="highlight">{{ $t('infra_takeover.txt1') }}</p>
        <ul class="list">
          <li
            v-for="(value, key) in $t('infra_takeover.txt2')
              .split('\n')
              .filter(Boolean)"
            :key="key"
            class="listItem"
          >
            <img class="checkIcon" src="~@/assets/homePage/bullet_ic.svg" />
            <span>{{ value }}</span>
          </li>
        </ul>
        <p class="ctaText">{{ $t('infra_takeover.txt3') }}</p>
        <router-link class="link" :to="`/${locale}/contact`">{{
          $t('infra_takeover.button')
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../i18n';

export default {
  data() {
    return {
      locale: i18n.locale,
    };
  },
};
</script>

<style scoped>
.Parent {
  background: var(--qwray);
  padding: 62px 0 62px 0;
}
.image {
  margin-bottom: 50px;
}
.smallHeader {
  font: normal normal normal 16px/60px Lato;
  letter-spacing: 2.4px;
  color: #ffffff;
}
.bigHeader {
  font: normal normal bold 30px/40px Foco;
  letter-spacing: 0px;
  color: #ffffff;
}
.highlight {
  font: normal normal normal 14px/20px Lato;
  letter-spacing: 0px;
  color: #ffdf22;
  margin: 32px 0 30px 0;
}
.list {
  font: normal normal normal 14px/20px Lato;
  letter-spacing: 0px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 50px;
}
.listItem {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.checkIcon {
  flex-shrink: 0;
  margin-top: 5px;
  height: 18px;
  width: 20px;
}
.ctaText {
  font: normal normal bold 14px/20px Lato;
  letter-spacing: 0px;
  color: #ffffff;
  margin-bottom: 40px;
}
.link {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 30px;
  background: var(--qwellow);
  font: normal normal bold 17px/24px Lato;
  letter-spacing: 0px;
  color: #2b4047;
  min-height: 40px;
  padding: 0.5em 2.2em;
  display: grid;
  align-items: center;
  width: max-content;
  margin: 0 auto;
}
@media (min-width: 769px) {
  .Parent {
    padding: 92px 0 92px 0;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 100px;
    max-width: 2400px;
  }
  .smallHeader {
    font-size: 20px;
    line-height: 1;
    margin-bottom: 40px;
  }
  .bigHeader {
    font-size: 40px;
    line-height: 50px;
  }
  .link {
    margin-left: auto;
    margin-right: 0;
  }
  .highlight {
    font-size: 20px;
    margin: 40px 0 32px 0;
    line-height: 24px;
  }
  .list {
    gap: 17px;
  }
  .listItem {
    font-size: 20px;
    line-height: 24px;
  }
  .ctaText {
    font-size: 20px;
    line-height: 26px;
  }
  .link {
    font-size: 20px;
    padding: 0.5em 2.9em;
  }
}
</style>
